import React from 'react';
import { Field, reduxForm } from 'redux-form';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import validator from 'validator';
import { NODE_ENV } from 'env';
import { validatePassword } from 'utils/passwordValidator';
import { Trans, t } from '@lingui/macro';
import { I18n } from '@lingui/react';
import i18nInstance from '@moka-bo/i18n';
import { businessSales, businessStarts } from '../../state/action-mess';
import PhoneNumberField from '../Fields/ReduxForm/PhoneNumberField';
import Captcha from './Captcha';
import styles from './style.css';

const validate = values => {
  let errors = {};
  if (!values.emailAddress) {
    errors.emailAddress = i18nInstance._(t`Enter your email address`);
  } else if (values.emailAddress.trim().length < 1) {
    errors.emailAddress = i18nInstance._(t`Enter your email address`);
  } else if (!values.emailAddress.includes('@')) {
    errors.emailAddress = i18nInstance._(
      t`Please include an ‘@’ in your email address`
    );
  } else if (
    !validator.isEmail(values.emailAddress) ||
    (NODE_ENV.toLowerCase === 'development' &&
      values.emailAddress.includes('@mailinator'))
  ) {
    errors.emailAddress = i18nInstance._(t`Enter a valid email address`);
  }
  if (!values.userFirstName) {
    errors.userFirstName = i18nInstance._(t`Enter name as shown on your ID`);
  } else if (values.userFirstName.trim().length < 1) {
    errors.userFirstName = i18nInstance._(t`Enter name as shown on your ID`);
  }

  errors = validatePassword(values.password, null);

  if (!values.userPhone) {
    errors.userPhone = i18nInstance._(t`Enter your phone number`);
  } else if (
    values.userPhone[0] !== '8' ||
    values.userPhone.length < 9 ||
    values.userPhone.length > 12
  ) {
    errors.userPhone = i18nInstance._(t`Enter a valid phone number`);
  }
  if (!values.captcha) {
    errors.captcha = true;
  }

  return errors;
};

const inputField = field => {
  return (
    <div>
      <input
        {...field.input}
        type={field.type || 'text'}
        maxLength={field.maxLength}
        className={`form-control ${styles['input-style']} ${
          field.meta.touched && field.meta.error ? styles['input-error'] : ''
        }`}
        placeholder={field.placeholder}
        onKeyPress={e => (field.onKeyPress ? field.setOnlyNumber(e) : '')}
      />
      <small className={styles.error}>
        {field.meta.touched ? field.meta.error : ''}
      </small>
    </div>
  );
};

const passwordField = field => {
  return (
    <div>
      <input
        {...field.input}
        type={field.type || 'password'}
        maxLength={field.maxLength}
        className={`form-control ${styles['input-style']} ${
          styles['password-field']
        } ${
          field.meta.touched && field.meta.error ? styles['input-error'] : ''
        }`}
        placeholder={field.placeholder}
        onKeyPress={e => (field.onKeyPress ? field.setOnlyNumber(e) : '')}
      />
      <small
        className={`${
          field.meta.error && field.meta.touched
            ? styles.error
            : styles['password-msg']
        }`}
      >
        {field.meta.error && field.meta.touched ? (
          <Trans id={field.meta.error} />
        ) : (
          <Trans>
            Must contains both lowercase and uppercase characters, at least one
            number, and minimum 8 characters
          </Trans>
        )}
      </small>
    </div>
  );
};

const emailField = field => {
  return (
    <div>
      <input
        {...field.input}
        type="text"
        maxLength={field.maxLength}
        className={`form-control ${styles['input-style']} ${
          field.meta.touched && field.meta.error ? styles['input-error'] : ''
        }`}
        autoCorrect="off"
        autoCapitalize="off"
        spellCheck="false"
        placeholder="Email"
      />
      <small className={styles.error}>
        {field.meta.touched ? <Trans id={field.meta.error} /> : ''}
      </small>
    </div>
  );
};

let ProfileSetupForm = class profileSetupForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showPassword: false,
    };
  }

  componentDidMount() {
    this.props.dispatch(businessStarts());
    this.props.dispatch(businessSales());
    if (this.props.data.registerForm.registrationForm.user) {
      this.handleInitialize();
    }
  }

  handleInitialize() {
    const {
      user: { email, full_name, phone },
      referral_id,
    } = this.props.data.registerForm.registrationForm;
    const initData = {
      userFirstName: full_name,
      userPhone: phone.slice(3),
      emailAddress: email,
      captcha: null,
      password: null,
      referral: referral_id,
    };
    this.props.initialize(initData);
  }

  toggleEye = () => {
    this.setState({
      showPassword: !this.state.showPassword,
    });
  };

  render() {
    const { handleSubmit, showChapcha, valid } = this.props;
    return (
      <form onSubmit={handleSubmit}>
        <div className="row section-personal-1">
          <div className="col-xs-12 col-sm-12 col-md-12">
            <div className={styles['form-group']}>
              <I18n>
                {({ i18n }) => (
                  <Field
                    component={inputField}
                    name="userFirstName"
                    placeholder={i18n._(t`Name as shown on ID`)}
                    autoCorrect="off"
                    maxLength="30"
                    autoCapitalize="off"
                    spellCheck="false"
                  />
                )}
              </I18n>
            </div>
          </div>
        </div>
        <div className="row section-personal-3">
          <div className="col-xs-12 col-sm-12">
            <div className={styles['form-group']}>
              <Field
                component={PhoneNumberField}
                name="userPhone"
                type="tel"
                placeholder="812342345"
                errorRegister
                customErrorClassName={styles['input-error']}
                showTextError
              />
            </div>
          </div>
        </div>
        <div className="row section-personal-1">
          <div className="col-xs-12 col-sm-12">
            <div className={styles['form-group']}>
              <Field
                component={emailField}
                name="emailAddress"
                maxLength="255"
              />
            </div>
          </div>
        </div>
        <div className="row section-personal-2">
          <div className="col-xs-12 col-sm-12">
            <div className={styles['form-group']}>
              <I18n>
                {({ i18n }) => (
                  <Field
                    component={passwordField}
                    name="password"
                    type={this.state.showPassword ? 'text' : 'password'}
                    maxLength="255"
                    placeholder={i18n._(t`Your Password`)}
                    autoCorrect="off"
                    autoCapitalize="off"
                    spellCheck="false"
                  />
                )}
              </I18n>

              <div className={`${styles.eyes}`} onClick={this.toggleEye}>
                {this.state.showPassword ? (
                  <span className="glyphicon glyphicon-eye-open" />
                ) : (
                  <span className="glyphicon glyphicon-eye-close" />
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="row section-personal-1">
          <div className="col-xs-12 col-sm-12 col-md-12">
            <div className={styles['form-group']}>
              <I18n>
                {({ i18n }) => (
                  <Field
                    component={inputField}
                    name="referral"
                    placeholder={i18n._(t`Referral Code (Optional)`)}
                    autoCorrect="off"
                    maxLength="30"
                    autoCapitalize="off"
                    spellCheck="false"
                  />
                )}
              </I18n>
            </div>
          </div>
        </div>
        <div
          className={`row section-captcha ${styles['margin-bottom-20']} ${
            styles['align-left-normal']
          }`}
        >
          <div className="col-xs-12 col-sm-12">
            <center className={`${styles['margin-bottom-30']}`}>
              {showChapcha === 'disablechapcha' &&
              NODE_ENV === 'development' ? (
                ''
              ) : (
                <Field component={Captcha} name="captcha" />
              )}
            </center>
          </div>
        </div>
        <div className={`row section-business-1`}>
          <div className="col-sm-12">
            <button
              className="btn btn-primary btn-block"
              type="submit"
              disabled={!valid}
            >
              <Trans>Sign up</Trans>
            </button>
          </div>
          <div className="col-sm-12">
            <div className={styles['margin-top-25']} />
            <p className={`${styles['term-policy']}`}>
              <Trans>
                By signing up, you agree to Moka’s{' '}
                <b>
                  <a
                    href="https://www.mokapos.com/terms"
                    target="_blank"
                    className={styles.link}
                  >
                    {' '}
                    Terms of Services
                  </a>
                </b>{' '}
                and have read Moka’s{' '}
                <b>
                  <a
                    href="https://www.mokapos.com/privacy"
                    target="_blank"
                    className={styles.link}
                  >
                    {' '}
                    Privacy Policy
                  </a>
                </b>
                .
              </Trans>
            </p>
          </div>
          {this.props.showNotificationCookie && (
            <div
              className={`${styles.mask} no-padding visible-lg visible-md`}
              onClick={this.props.handleOnclickNotificationCookie}
            >
              <div className={`${styles['mask-content']}`}>
                <div className={`no-padding text-left`}>
                  <Trans>
                    This website uses cookies. By continuing to use this
                    website, you consent to our use of these cookies.
                  </Trans>
                </div>
                <a href="#" className={`${styles['glyp-remove']} text-right`}>
                  <span className="glyphicon glyphicon-remove" />
                </a>
              </div>
            </div>
          )}
        </div>
        <div className="row section-line-3">
          <div className="col-xs">
            <div
              className={`${styles['mk-divider-section-line-bottom']} ${
                styles['margin-bottom-15']
              }`}
            />
          </div>
        </div>
        <div
          className={`row section-submit ${styles['margin-bottom-30']} ${
            styles['align-left-normal']
          }`}
        >
          <div className="col-sm-12">
            <center>
              <div
                className={`visible-sm visible-md visible-lg ${
                  styles['margin-top-10']
                }`}
              />
              <label className={styles['font-size-md']}>
                <Trans>
                  Already have a Moka account?{' '}
                  <a
                    href="/login"
                    className={`${styles.link} ${styles['sign-in-link']}`}
                  >
                    Sign In
                  </a>
                </Trans>
              </label>
              <div className={`visible-xs ${styles['margin-bottom-10']}`} />
            </center>
          </div>
        </div>
      </form>
    );
  }

  static setOnlyNumber(e) {
    const regex = /[0-9:]+/g;
    if (!regex.test(e.key)) {
      e.preventDefault();
    }
  }
};

ProfileSetupForm.propTypes = {
  dispatch: PropTypes.func,
  data: PropTypes.object,
  onSubmit: PropTypes.func,
  error: PropTypes.object,
  currentlySending: PropTypes.bool,
  pBusinessLocations: PropTypes.array,
  pBusinessCategoriesAll: PropTypes.array,
};

ProfileSetupForm = reduxForm({
  form: 'profileSetupForm',
  touchOnBlur: false,
  touchOnChange: true,
  validate,
})(ProfileSetupForm);

function select(state) {
  return {
    data: state,
  };
}
export default connect(select)(ProfileSetupForm);
